import { Component, OnInit, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSnackBar, MatDialogConfig } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogboxComponent } from '../../../public/dialogbox/dialogbox.component';
import { GradeService } from 'src/app/shared/services/grade.service';
import { AppSettings } from '../../../app.constant';
import { DataSource } from '@angular/cdk/table';

@Component({
  selector: 'app-grade-table',
  templateUrl: './grade-table.component.html',
  styleUrls: ['./grade-table.component.css']
})

export class GradeTableComponent implements OnInit {
  fileNameDialogRef: MatDialogRef<DialogboxComponent>;
  displayedColumns: string[] = ['Grade', 'GradeDesc', 'GradePoint', 'GradeMin', 'GradeMax', 'Edit'];
  post: any;
  httpResponseMessage: any;
  resultdata: any;
  dataSource;
  status: any;
  Grade: any;
  errorMessage: String;
  progressBar: boolean = true;

  @Output() messageEvent = new EventEmitter<string>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private _gradeservice: GradeService,
    changeDetectorRefs: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    public dialog: MatDialog, ) { }

  ngOnInit() {
    this._gradeservice.refreshNeeded$
      .subscribe(() => {
        this.getAllGrade();
      })
    this.getAllGrade();
  }

  getAllGrade() {
    this._gradeservice.getAllGrade(AppSettings.API_ENDPOINT + AppSettings.GetAllGrade)
      .subscribe(result => {
        this.resultdata = result;
        this.progressBar = false;
        if (!result) {
          return;
        }

        this.dataSource = new MatTableDataSource(this.resultdata);
        this.dataSource.paginator = this.paginator;
      });
  }

  onEditGrade(param: any): void {
    var o = { PK_GradeID: param.PK_GradeID }
    this.post = JSON.stringify(o);
    this._gradeservice.getGradeByID(AppSettings.API_ENDPOINT + AppSettings.GetGradeByID, this.post).subscribe(
      data => {
        this.Grade = data;
        console.log(this.Grade);
        this.messageEvent.emit(this.Grade);
      },
      error => this.errorMessage = <any>error)
  }

  onDeleteGrade(param: any): void {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      title: "Grade",
      data: param.Grade
    };

    this.fileNameDialogRef = this.dialog.open(DialogboxComponent, dialogConfig);
    this.fileNameDialogRef.afterClosed().subscribe(result => {
      this.status = result;
      if (this.status == "ok") {
        var o = { PK_GradeID: param.PK_GradeID }
        this.post = JSON.stringify(o);
        this._gradeservice.deleteGradeByID(AppSettings.API_ENDPOINT + AppSettings.DeleteGrade, this.post).subscribe(
          data => {
            this.httpResponseMessage = data;
            this.openSnackBar(this.httpResponseMessage, '');
          },
          error => this.errorMessage = <any>error)
      }
    });


  }

  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }

}
